<div class="form-shell-tabs">
  <div class="tabs-navigation-wrapper">
    <div class="tabs-navigation">
      <div
        *ngFor="let tab of tabs; trackBy: trackByTabId"
        class="tab-item"
        [class.active]="activeTab === tab.id"
        [class.disabled]="tab.disabled"
        [class.completed]="tab.completed"
        [class.required]="tab.required"
        [attr.aria-disabled]="tab.disabled || tab.locked"
        (click)="onTabClick(tab.id)">
        <i *ngIf="tab.icon" [class]="tab.icon"></i>
        <span class="tab-label">{{ tab.label }}</span>
        <span *ngIf="tab.required" class="required-indicator">*</span>
        <i
          *ngIf="tab.locked"
          class="fas fa-lock tab-lock-icon"
          [attr.title]="tab.lockedTitle || 'Bloqueado'">
        </i>
      </div>
    </div>
  </div>
</div>

<ng-content></ng-content>

